import { render } from "./PreopFormView.vue?vue&type=template&id=430473aa"
import script from "./PreopFormView.vue?vue&type=script&lang=js"
export * from "./PreopFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__